const axios = require('axios');
const configuredBaseUrl = process.env.VUE_APP_BACKEND_API_URL;
const useHttpsDevelopmentProxy =
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    /^http:\/\//i.test(configuredBaseUrl || '');

axios.defaults.baseURL = useHttpsDevelopmentProxy ? '' : configuredBaseUrl;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

module.exports = {
    axios
}
